import React, {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";

import SectionBox from "../../elements/SectionBox/SectionBox";
import CampaignAdElement from "./CampaignAdElement";

import {callAPI} from "../../utils/utils";

import "./CampaignDetailsPage.scss";
import Button from "../../elements/Button/Button";

const CampaignAdsBox = (props) => {
  const { t } = useTranslation();
  const [ campaignAds, setCampaignAds ] = useState(null);
  const [ loading, setLoading ] = useState(true);
  const [ size, setSize] = useState('small');

  useEffect(() => {
    callAPI("campaigns/ads", "POST", {hash: props.hash, category: props.category }).then((data) => {
      setCampaignAds(data.campaignAds);
      setLoading(false);
    });
  }, [props.hash, props.category]);

  const campaignsAdsHtml = !campaignAds ? <></> : campaignAds.map((item, index) => {
    return <CampaignAdElement key={index} ad={item} size={size}/>;
  });

  return (
    <SectionBox loading={loading} headline={"CampaignAdsBox.Headline." + props.category} info={"CampaignAdsBox.InfoText." + props.category} width={1000}>
      {props.category !== 'text' && <>
      <div className={'campaign-ads__preview_buttons'}>
        <Button
          type="submit"
          size="large"
          variant="contained"
          color="primary"
          className="submit"
          onClick={() => {setSize("small")}}
        >
          {t("CampaignAdsBox.PreviewSmall")}
        </Button>
        <Button
          type="submit"
          size="large"
          variant="contained"
          color="primary"
          className="submit"
          onClick={() => {setSize("medium")}}
        >
          {t("CampaignAdsBox.PreviewMedium")}
        </Button>
        <Button
          type="submit"
          size="large"
          variant="contained"
          color="primary"
          className="submit"
          onClick={() => {setSize("large")}}
        >
          {t("CampaignAdsBox.PreviewLarge")}
        </Button>
        <Button
          type="submit"
          size="large"
          variant="contained"
          color="primary"
          className="submit"
          onClick={() => {setSize("huge")}}
        >
          {t("CampaignAdsBox.PreviewHuge")}
        </Button>
      </div></>}

      <div className={'campaign-ads__box ' + props.category + ' ' + size}>
        { campaignAds && <>{campaignsAdsHtml}</> }
      </div>
    </SectionBox>
  );
}

export default CampaignAdsBox;